import React from "react";

import { IgButton } from "@intelligems/ig-theme";
import { EmbeddedPreviewError } from "@src/features/experienceBuilder/pageState/EmbeddedPreviewError";
import { useDialog } from "@src/hooks/dialog";
import { useDispatch } from "react-redux";
import { ExperienceBuilderAction } from "@src/store/slices/experienceBuilder";

export const PluginNotDetectedError = () => {
  const dispatch = useDispatch();
  const dialog = useDialog("scriptTag");

  const onClose = () =>
    dispatch(ExperienceBuilderAction.dismissPageState("pluginTimeout"));

  return (
    <EmbeddedPreviewError
      title={"Preview not available"}
      description={"Our script isn't detected on your site"}
      buttons={
        <IgButton
          variant="contained"
          color="warning"
          onClick={() => dialog.open()}
          sx={{ flex: 1 }}
        >
          Connect Intelligems
        </IgButton>
      }
      onClose={onClose}
    />
  );
};
